import { useQuery } from "@tanstack/react-query";

import { ListConfigsQueryFilters, UseListConfigsQueryOptions } from "./types";
import { getConfigsService } from "./service";

export const listConfigsQueryKey = ["v1/agreement_integration_config_admin"];

export function useListConfigsQuery(
  filters?: ListConfigsQueryFilters,
  options?: UseListConfigsQueryOptions
) {
  const queryKey = listConfigsQueryKey.concat(JSON.stringify(filters));

  return useQuery({
    queryKey,
    queryFn: async () => getConfigsService(filters),
    ...options,
  });
}
